// @flow
import { createParser, fields, compose } from '../utils/parse';

const Image = createParser('Image', {
  alt: fields.string('', { path: 'image_alt' }),
  color: fields.string('', { path: 'background_color' }),
  link: fields.string('', { path: 'image_link' }),
  linkTarget: fields.string('', { path: 'image_link_target' }),
  size: fields.string('', { path: 'image_size' }),
  src: fields.string('', { path: 'image_src' }),
});

const Dek = createParser('Dek', {
  style: fields.string('', { path: 'style' }),
  text: fields.string('', { path: 'text' }),
});

const DeviceData = createParser('DesktopData', {
  dek: fields.object(Dek, { path: 'dek' }),
  image: fields.object(Image, { path: 'image' }),
});

const Logo = createParser('Logo', {
  alt: fields.string('', { path: 'image_alt' }),
  src: fields.string('', { path: 'image_src' }),
});

export const PromoBanner = createParser('PromoBanner', {
  desktop: fields.object(DeviceData, { path: 'desktop' }),
  hideNavNodeTitle: fields.bool(false, { path: 'hide_nav_node_title' }),
  logo: fields.object(Logo, { path: 'logo' }),
  mobile: fields.object(DeviceData, { path: 'mobile' }),
});

export default compose(PromoBanner);
